var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 634.2 402.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-body-1 {\n        fill: #d61800;\n      }\n\n      .cls-body-2 {\n        fill: var(--custom-color, #fa) !important;\n      }\n\n      .cls-body-3 {\n        fill: #fff;\n      }\n\n      .cls-skin-color {\n        fill: var(--custom-skin-color, #dd8f5f) !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-3",
    cx: 223.57,
    cy: 359.71,
    rx: 53.91,
    ry: 42.08,
    transform: "translate(-87.34 72.11) rotate(-15.37)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-1",
    cx: 225.75,
    cy: 353.18,
    rx: 53.91,
    ry: 42.08,
    transform: "translate(-85.53 72.46) rotate(-15.37)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-3",
    cx: 403.28,
    cy: 359.71,
    rx: 42.08,
    ry: 53.91,
    transform: "translate(-50.45 653.24) rotate(-74.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-1",
    cx: 401.1,
    cy: 353.18,
    rx: 42.08,
    ry: 53.91,
    transform: "translate(-45.75 646.33) rotate(-74.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M544.73,155.64c-.77.06-1.53.12-2.28.16-28.59,1.67-54.42-17.08-62.51-44.55l-25.77-87.56H188.42v.28l-25.74,86.97c-8.13,27.45-33.95,46.17-62.54,44.5-.75-.04-1.51-.1-2.28-.16l-1.35,14.74c-.77,8.4-.57,16.86.61,25.22h0c7.94,56.19,52.7,104.16,115.88,130.12,18.29,7.52,38.15,13.16,59.08,16.65,1.62.28,3.24.55,4.85.8,14.34,2.14,29.18,3.28,44.36,3.28,118,0,214.81-67.89,224.62-154.35,0-.05.01-.1.02-.14.82-7.31.78-14.69.1-22.01l-1.3-13.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M211.62,70.87l-43.08-29.62-90.47,131.61c-6.03-2.09-12.51-3.24-19.25-3.24-32.48,0-58.81,26.33-58.81,58.81s26.33,58.81,58.81,58.81,58.81-26.33,58.81-58.81c0-5.96-.89-11.71-2.54-17.14l96.54-140.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M422.59,70.87l43.08-29.62,90.47,131.61c6.03-2.09,12.51-3.24,19.25-3.24,32.48,0,58.81,26.33,58.81,58.81s-26.33,58.81-58.81,58.81c-32.48,0-58.81-26.33-58.81-58.81,0-5.96.89-11.71,2.54-17.14l-96.54-140.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M170.47,131.31c15.26-6.67,30.42-20.42,41.35-39.19,20.39-35.03,18.3-74.27-4.67-87.64-22.97-13.37-58.12,4.19-78.51,39.23-10.93,18.77-15.39,38.75-13.65,55.31l55.48,32.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M457.53,131.31c-15.26-6.67-30.42-20.42-41.35-39.19-20.39-35.03-18.3-74.27,4.67-87.64,22.97-13.37,58.12,4.19,78.51,39.23,10.93,18.77,15.39,38.75,13.65,55.31l-55.48,32.29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseBody);
export default __webpack_public_path__ + "static/media/base-body.77b6f522ef614cb1720e4df0c54fc06f.svg";
export { ForwardRef as ReactComponent };